import { testIDFactory } from '@onepercentio/one-ui/utils/e2e'

export const DROP_DETAILS_TEST_IDS = testIDFactory('drop-details')(['QUANTITY'])
